<div class="container-fluid competition" [ngClass]="{'transition-ready': competition}">
  <div class="row">
    <div class="col-12 col-md-12 col-lg-7 info p-1 mb-4 mb-xs-4 mb-sm-4 mb-md-0">
      <div class="logo" *ngIf="competition?.logoUrl"
        [style.background-image]="'url(' + competition?.logoUrl + ')'">
      </div>
      <div class="title text-uppercase">UEFA</div>
      <div class="title text-uppercase">{{ competition?.displayName }}</div>
    </div>
    <div class="col-12 col-md-12 offset-lg-1 col-lg-4 p-1 d-flex justify-content-center justify-content-md-end end">
      <div class="stadium-container">
        <picture class="btn btn-link p-0" [routerLink]="['stadium']">
          <source srcset="/assets/img/stadium-illustration.png" media="(max-width: 768px)">
          <source srcset="/assets/img/stadium-illustration@2x.png" media="(max-width: 2999px) and (min-width: 769px)">
          <source srcset="/assets/img/stadium-illustration@3x.png" media="(min-width: 3000px)">
          <img src="/assets/img/stadium-illustration.png" class="stadium-illustration">
        </picture>
        <button type="button" class="btn btn-link link-arrow float-right text-right text-uppercase mt-3"
          [routerLink]="['stadium']">view stadium details <i class="icon icon-arrow-fwd-sm-link"></i>
        </button>
      </div>
    </div>
  </div>
</div>
